import axios from '@/plugins/axios'
import {Message} from "element-ui";

export default {
  namespaced: true,

  state: {
    loading: false,
    page: 1,
    page_size: 10,
    order_column: 'published_at_utc',
    order_type: 'desc',
    approval: [],
    tracks: [],
    dialog_track: false,
    dialog_upload: false,
    track: {},
    upload_image: null,
    track_chart: [],
    genres: [],
    moods: [],
    image: null,
    contract: {
      first_name: null,
      last_name: null,
      address: null,
      company_name: null,
      company_address: null,
      artist_id: null,
      signed: 0
    },
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setApproval(state, payload) {
      state.approval = payload
    },
    setMyTracks(state, payload) {
      state.tracks = payload
    },
    setDialogTrack(state, payload) {
      state.dialog_track = payload
    },
    setDialogUpload(state, payload) {
      state.dialog_upload = payload
    },
    setTrack(state, payload) {
      state.track = payload
      if (state.track.timing_start)
        state.track.timing = [payload.timing_start, payload.timing_end]
    },
    setTiming(state, payload) {
      state.track.timing = [payload.date_start, payload.date_end]
      state.track.timing_start = payload.date_start
      state.track.timing_end = payload.date_end
    },
    setUploadImage(state, payload) {
      state.upload_image = payload
    },
    setTrackChart(state, payload) {
      state.track_chart = payload
    },
    setTrackVideos(state, payload) {
      state.videos = payload
    },
    setGenres(state, payload) {
      state.genres = payload
    },
    setMoods(state, payload) {
      state.moods = payload
    },
    setImage(state, payload) {
      state.image = payload
    },
    setContract(state, payload) {
      state.contract = payload
    },
  },

  actions: {
    readMyTracks({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('artist_track_filter')
      filters = JSON.parse(ls)

      if (
        filters !== null &&
        filters.date_range !== null &&
        filters.date_range.length > 0
      ) {
        filters.date_start = filters.date_range[0]
        filters.date_end = filters.date_range[1]
        delete filters.date_range
      }

      axios.artist
        .get('mytracks', {
          params: {
            artist:
              this.state.artistDashboard.artist_label !== null
                ? this.state.artistDashboard.artist_label.id
                : null,
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          commit('setMyTracks', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readForApproval({ commit },filters) {
      commit('setLoading', true)
      axios.artist
        .get('mytracks/approval', {
          params: {
            artist:
              this.state.artistDashboard.artist_label !== null
                ? this.state.artistDashboard.artist_label.id
                : null,
            ...filters
          }
        })
        .then(r => {
          commit('setApproval', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    update({ commit, dispatch, state }) {
      axios.artist
          .post('mytracks', {
            id: state.track.id,
            title: state.track.title,
            artist_id: state.track.artist_id,
            isrc: state.track.isrc,
            spotify_link: state.track.spotify_link,
            image_url:  state.track.image_url,
            image:  state.image
          })
          .then(() => {
            commit('setDialogTrack', false)
            dispatch('readForApproval')
          })
    },

    updatePublish({ dispatch, commit, state }, id) {
      axios.artist
          .put(`mytracks/track/${id}`, {
            id: state.track.id,
            title: state.track.title,
            track_genres: state.track.track_genres,
            moods: state.track.moods,
            isrc: state.track.isrc,
            spotify_link: state.track.spotify_link,
            artist_id: state.track.artist_id,
            image_url:  state.track.image_url,
            image:  state.image
          })
          .then(() => {
            commit('setDialogTrack', false)
            dispatch('readMyTracks')
          })
    },

    deleteTrack({ dispatch }, id) {
      axios.artist
        .post('mytracks/delete/track', {
          track_id: id
        })
        .then(() => {
          dispatch('readForApproval')
        })
    },
    deleteImage({ dispatch }, id) {
      axios.artist
        .post('mytracks/delete/image', {
          track_id: id
        })
        .then(() => {})
    },
    confirmTrack({ dispatch }, track) {
      axios.artist
        .post('mytracks', {
          id: track.id,
          name: track.name,
          release_date: track.release_date,
          cid_manager: track.cid_manager,
          distributor: track.distributor,
          isrc: track.isrc,
          spotify_link: track.spotify
        })
        .then(() => {
          dispatch('readForApproval')
        })
    },
    uploadImage({ dispatch, commit, state }, image) {
      axios.artist.post('mytracks/upload/image/'+image.id, image).then(r => {
        dispatch('readForApproval')
        commit('setUploadImage', r.data.data)
      })
    },
    userPublish({ dispatch, commit }, id = null) {
      let track_id = id ? [id] : id
      commit('setLoading', true)
      axios.artist
          .post('mytracks/user-publish', {
            tracks: track_id
          })
          .then(() => {
            Message({
              type: 'success',
              message: 'Publish completed'
            })
            dispatch('readForApproval')
          })
          .catch(e => {
            commit('setLoading', false)
            Message({
              type: 'error',
              message: 'Publish failed:' + e
            })
          })
    },

    async createContract({ dispatch, commit, state }){
      await axios.artist
          .post('contracts', state.contract)
    },

    async signContract({ dispatch, commit, state }){
      await axios.artist
          .post('contracts/sign', {
            artist_id: state.contract.artist_id
          })
    },

    checkContract({ commit, state }) {
      commit('setLoading', true)
      axios.artist
          .get('contracts', {
            params: {
              artist:
                  this.state.artistDashboard.artist_label !== null
                      ? this.state.artistDashboard.artist_label.id
                      : null,
              type: 1
            }
          })
          .then(r => {
            let contract = {
                  first_name: null,
                  last_name: null,
                  address: null,
                  company_name: null,
                  company_address: null,
                  artist_id: null,
                  signed: 0
                };
            if(r.data.data.length > 0){
              commit('setContract', r.data.data[0])
            }
            else{
              commit('setContract', contract)
            }
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
  },

  getters: {
    track_chart_views: state => {
      let result = [['Date', 'Views']]
      state.track_chart.map(s => {
        if (s[1] !== 'Views') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), parseInt(s[1])])
        }
      })
      return result
    },
    track_chart_views_daily: state => {
      let result = [['Date', 'Daily']]
      state.track_chart.map(s => {
        if (s[2] !== 'Daily') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[2]])
        }
      })
      return result
    },
    track_chart_previews: state => {
      let result = [['Date', 'Previews']]
      state.track_chart.map(s => {
        if (s[3] !== 'Previews') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[3]])
        }
      })
      return result
    },
    track_chart_previews_daily: state => {
      let result = [['Date', 'Daily']]
      state.track_chart.map(s => {
        if (s[4] !== 'Daily Previews') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[4]])
        }
      })
      return result
    },
    track_chart_downloads: state => {
      let result = [['Date', 'Downloads']]
      state.track_chart.map(s => {
        if (s[5] !== 'Downloads') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[5]])
        }
      })
      return result
    },
    track_chart_downloads_daily: state => {
      let result = [['Date', 'Daily Downloads']]
      state.track_chart.map(s => {
        if (s[6] !== 'Daily Downloads') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[6]])
        }
      })
      return result
    },
    track_chart_subscribers: state => {
      let result = [['Date', 'Subscribers']]
      state.track_chart.map(s => {
        if (s[7] !== 'Subscribers') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[7]])
        }
      })
      return result
    },
    track_chart_subscribers_daily: state => {
      let result = [['Date', 'Daily']]
      state.track_chart.map(s => {
        if (s[8] !== 'Daily Subscribers') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[8]])
        }
      })
      return result
    }
  }
}
